// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22V2H2V22H22ZM5.48242 8.17383L17.0732 5.06836L18.1084 8.93164L14.2451 9.9668L16.5742 18.6602L12.7109 19.6963L10.3818 11.0029L6.51758 12.0381L5.48242 8.17383Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-tapd-filled')
export default class LogoTapdFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-tapd-filled',
    }
  }
}
